var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"dashboard-card"},[_c('header',{staticClass:"dashboard-card-header"},[_vm._v(_vm._s(_vm.header))]),_c('main',{staticClass:"dashboard-card-main"},[_vm._v(_vm._s(_vm.main))]),_c('footer',{staticClass:"dashboard-card-footer"},[_vm._v(_vm._s(_vm.footer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }